import { storageService } from 'acerto-ds-services';
import DevConfig from '@/services/DevOverlay/DevConfig';

interface DevStorageDataInput {
  config: Record<string, unknown>;
}

interface DevStorageDataOutput {
  config: DevConfig;
}

function isRecord(obj: unknown): obj is Record<string, unknown> {
  return !!obj && typeof obj === 'object';
}

function isValidInput(obj: unknown): obj is DevStorageDataInput {
  return isRecord(obj)
    && 'config' in obj
    && isRecord(obj.config);
}

const defaultData: DevStorageDataOutput = { config: new DevConfig({}) };

function fromJSON(json: string) {
  const obj = JSON.parse(json);

  if (!isValidInput(obj)) return defaultData;

  return {
    config: new DevConfig(obj.config),
  };
}

function toJSON(config: DevStorageDataOutput) {
  return JSON.stringify(config);
}

export default new storageService.StorageEntry<DevStorageDataOutput>({
  key: 'acerto-dev',
  default: defaultData,
  serializer: { fromJSON, toJSON },
});
